import { createFileRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { DocumentTitle } from "@/components";
import { AutomationListPage, automationSortEnum } from "@/modules/automation";
import { requireAuthAndPermission } from "@/utils";

const automationListSearchSchema = z.object({
  q: fallback(z.string(), "").default(""),
  page: fallback(z.number(), 1).default(1),
  sort: fallback(automationSortEnum, "newest").default("newest")
});

export const Route = createFileRoute("/products/automation/")({
  validateSearch: zodValidator(automationListSearchSchema),
  beforeLoad: requireAuthAndPermission,
  component: () => (
    <>
      <DocumentTitle
        title="Product Automation"
        description="Manage automated provisioning for products on the LAMPU Marketplace."
      />
      <AutomationListPage />
    </>
  )
});
